/*---------------------------------------
  BOOTSTRAP
---------------------------------------*/
import $ from "jquery";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";

window.$ = $;
